import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../../context/LoaderContext";
import { ButtonGroup, Col, Container, Dropdown, Row} from "react-bootstrap";
import {  DotsThreeVertical, LockPasswordIcon, MagnifyingGlass} from "../../../constant/icons/icons";
import PaginationComponent from "../pagination/pagination";
import { fetchAllCutomers } from "../../../store/customerSlice";
import moment from "moment";
import ChangeCustomerPassword from "./ChangeCustomerPassword";


const List = () => {
  const limit = 10;
  const { setLoading } = useLoader();
  const dispatch = useDispatch();
  // Toast
  // const [showSnackbar, setShowSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarVariant, setSnackbarVariant] = useState("success");
  // search bar
  const [searchTerm, setSearchTerm] = useState("");
  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [openDropdown, setOpenDropdown] = useState({ id: null, type: null });
  const [openChangePw,setOpenChangePw] = useState(false);
  const [changePwId,setChangePwId] = useState("");

  const {data = [], total = 0} = useSelector((state) => state?.customer?.allCustomers || {});

  // console.log("data",data,"total",total);

  // Pagination Handler
  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber - 1);
  };

  const getAllCustomers = useCallback(() => {
    setLoading(true);
    dispatch(fetchAllCutomers({
      offset:currentPage,
      limit,
      search: searchTerm,
    }))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, currentPage, limit, searchTerm, setLoading]);

  useEffect(() => {
    getAllCustomers();
  }, [getAllCustomers]);

  const ChangePassword = (id) => {
    console.log("id",id);
    setOpenChangePw(true);
    setChangePwId(id);
  }

  const handleDropdownToggle = (id, type) => {
    if (openDropdown.id === id && openDropdown.type === type) {
      // Close the currently open dropdown
      setOpenDropdown({ id: null, type: null });
    } else {
      // Open the new dropdown and close any others
      setOpenDropdown({ id: id, type: type });
    }
  };

  const ActionMenu = ({ item, isOpen, toggleMenu }) => (
    <Dropdown
      drop="down"
      as={ButtonGroup}
      className="action-dropdown w-100 d-inline-block"
      show={isOpen}
      onToggle={() => handleDropdownToggle(item.id, "action")}
    >
      <Dropdown.Toggle
        id={`dropdown-split-basic-${item.id}`}
        className="p-0"
        variant="link"
        as={CustomToggle}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu(item.id);
        }}
      >
        <DotsThreeVertical size={17} color="#637381" weight="bold" />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="action-dr-menu z-1">
        <Dropdown.Item
          eventKey="1"
          className="d-flex align-items-center dr-item item-orange"
          onClick={(e) => {
            e.stopPropagation();
            ChangePassword(item?.id)
          }}
        >
          <span>
            <LockPasswordIcon size={15} color="#637381" weight="regular" />
          </span>
          <p className="mb-0">Change Password</p>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );



  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      className="text-muted text-primary-hover"
      role="button"
    >
      {children}
    </div>
  ));

  CustomToggle.displayName = "CustomToggle";

  // let total = 10;
  return (
    <>
      {/* <ToastContainer position="top-end" className=" pt-3 pe-3 cu-toster">
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
        >
          <Toast.Body className="d-flex align-items-center gap-2 text-white">
            <CheckCircle size={22} color="#ffffff" weight="duotone" />
            <p className="mb-0">{snackbarMessage}</p>
          </Toast.Body>
        </Toast>
      </ToastContainer> */}

      {/* Background color of a page */}
      <div className="bg-primary pt-10 pb-21"></div>
      <Container fluid className="mt-n22 px-6 pb-6">
        <Row>
          <Col lg={12} md={12} xs={12}>
            <div>
              <div>
                <h3 className="mb-0 fw-semibold pg-title text-white">
                  Organization
                </h3>
              </div>
            </div>
          </Col>

          <Col xl={12} lg={12} md={12} xs={12} className="mt-6">
            <div className="position-relative rounded-3 bg-white  tablecontainer">
              <div className="d-flex align-items-center justify-content-between gap-3 reseller-sea-btn mb-3">
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder="Search "
                    className="searchbar outline-none border-0 shadow-none "
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(0);
                    }}
                  />
                  <MagnifyingGlass
                    size={18}
                    color="#757779"
                    className="position-absolute top-50 start-0 ms-4 translate-middle"
                    weight="regular"
                  />
                </div>
                {/* <Button
                  variant="primary"
                  // onClick={handleAddCreditShow}
                >
                  Add Customer
                </Button> */}
              </div>
              {/* Tabs section */}
              {/* <div className="position-relative overflow-hidden rounded-2 bg-white table-tabs mb-3">
                <Tabs
                  defaultActiveKey=""
                  className="pb-0 table-tabs-items"
                  id="uncontrolled-tab-example"
                  // onSelect={handleTabSelect}
                >
                  <Tab
                    eventKey=""
                    title={
                      <>
                        <div className="d-flex align-items-center gap-2">
                          <p className="mb-0">All</p>
                        </div>
                      </>
                    }
                  ></Tab>
                </Tabs>
              </div> */}

              {/* Table */}
              <div  className="table-responsive rounded-2 mt-5 custom_table pg-table-scroll overflow-y-auto">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Organization Name</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("name")}
                          >
                            {/* {renderSortIcons("name")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Person Name</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("name")}
                          >
                            {/* {renderSortIcons("name")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Mobile Number</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("credit_rate")}
                          >
                            {/* {renderSortIcons("credit_rate")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Email</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("credit_rate")}
                          >
                            {/* {renderSortIcons("credit_rate")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Credits</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("credit_rate")}
                          >
                            {/* {renderSortIcons("credit_rate")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Expiry Date</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("credit_rate")}
                          >
                            {/* {renderSortIcons("credit_rate")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center gap-th">
                          <p className="mb-0 ">Created at</p>
                          <span
                            className="d-flex align-items-center"
                            // onClick={() => handleSort("credit_rate")}
                          >
                            {/* {renderSortIcons("credit_rate")} */}
                          </span>
                        </div>
                      </th>
                      <th className="fw-medium">
                        <div className="d-flex align-items-center justify-content-center gap-th">
                          <p className="mb-0">Action</p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {data?.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center border-bottom-0">
                        <p className="mt-5 mb-0 no-data text-capitalize">
                          No data available
                        </p>
                      </td>
                    </tr>
                  ) : (
                    data?.map((item,i) => (
                      <tr
                        key={item?.id}
                        className={`position-relative ${item.status === "placed" ? "cursor-pointer" : ""}`}>
                        <td>{item?.organization_name ? item?.organization_name : "-"}</td>
                        <td>{item?.name ? item?.name : "-"}</td>
                        <td>{item.mobile_number ? item.mobile_number :"-"}</td>
                        <td>{item?.email ? item?.email : "-"}</td>
                        <td>{item?.credits ? item?.credits : "-"}</td>
                        <td>{item?.expiry_date ? moment(item?.expiry_date).format("DD/MM/YYYY" ) : "-"}</td>
                        <td>{item?.created_at ? moment(item?.created_at).format("DD/MM/YYYY hh:mm A") : "-"}</td>                      
                        <td className="text-center">
                        <ActionMenu item={item} isOpen={openDropdown.id === item.id && openDropdown.type === "action"} toggleMenu={() => handleDropdownToggle(item.id, "action")} />
                      </td>
                      </tr>
                    ))
                  )}
                </tbody>
                </table>
              </div>

              {total > limit && (
                <div className="pt-4">
                  <PaginationComponent
                    totalItems={total}
                    itemsPerPage={limit}
                    currentPage={currentPage + 1}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <ChangeCustomerPassword changePwId={changePwId} show={openChangePw} handleClose={() => setOpenChangePw(false)} setOpenChangePw={setOpenChangePw}/>
    </>
  );
};

export default List;
